import React from 'react';
import moment from 'moment';
import {
  Container,
  Header,
  Segment,
  Icon,
  Image,
  Grid,
  Step,
  Button,
  Card,
  Label,
  Table,
  Dimmer
} from 'semantic-ui-react';
import DivWrapper from './DivWrapper';

import {FormattedMessage} from 'react-intl';
import appPreview from '../img/app_preview.png';
import Counter from './Counter';

import applePic from '../img/apple-badge.png';
import googlePlayPic from '../img/google-play-badge.png';

import { BACKGROUND_DARK, BACKGROUND_DARK2, PRIMARY_COLOR } from '../constants';
import AudoryCoinIcon from '../img/AudoryCoinIcon';

const PageHeader = ({mobile}) => (
    <Segment 
        inverted
        textAlign='center'
        style={{ padding: '0em 0em' }}
        vertical
      >
      <Container text style={{padding: '5em 0em'}}>
        <Header
            as='h1'
            inverted
            style={{
            fontSize: mobile ? '2em' : '4em',
            fontWeight: 'normal',
            marginBottom: 0,
            }}
        >
            <FormattedMessage id="audory.responsiveContainer.body.gutschein"/>
        </Header>
        <Header
            as='h2'
            inverted
            style={{
            fontSize: mobile ? '1.5em' : '1.7em',
            fontWeight: 'normal',
            }}
        >
            <FormattedMessage id="audory.responsiveContainer.body.gutschein.headText"/>
        </Header>
        
        </Container>
    </Segment>
)

function shuffle(a) {
    for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
}

const stories = shuffle([
    ['https://audory-static.s3.eu-central-1.amazonaws.com/alte_goetter.jpg', 'https://audory-static.s3.eu-central-1.amazonaws.com/alte_goetter.mp3'],
    ['https://audory-static.s3.eu-central-1.amazonaws.com/blut_der_feen.jpg', 'https://audory-static.s3.eu-central-1.amazonaws.com/blut_der_feen.mp3'],
    ['https://audory-static.s3.eu-central-1.amazonaws.com/finleys_reise.jpg', 'https://audory-static.s3.eu-central-1.amazonaws.com/pandemia.mp3'],
    ['https://audory-static.s3.eu-central-1.amazonaws.com/kalte_schatten.jpg', 'https://audory-static.s3.eu-central-1.amazonaws.com/kalte_schatten.mp3'],
    ['https://audory-static.s3.eu-central-1.amazonaws.com/kloster_der_angst.jpg', 'https://audory-static.s3.eu-central-1.amazonaws.com/kloster_der_angst.mp3'],
    ['https://audory-static.s3.eu-central-1.amazonaws.com/liebe_hoch_drei.jpg', 'https://audory-static.s3.eu-central-1.amazonaws.com/liebe_hoch_drei.mp3'],
    ['https://audory-static.s3.eu-central-1.amazonaws.com/sommer_1986.jpg', 'https://audory-static.s3.eu-central-1.amazonaws.com/sommer_1986.mp3'],
    ['https://audory-static.s3.eu-central-1.amazonaws.com/vielleicht_beim_dritten_date.jpg', 'https://audory-static.s3.eu-central-1.amazonaws.com/vielleicht_beim_dritten_date.mp3'],
    ['https://audory-static.s3.eu-central-1.amazonaws.com/nano.jpg', 'https://audory-static.s3.eu-central-1.amazonaws.com/nano.mp3'],
]);


let releaseDate = moment('2020-12-10 09:00:00');
let currentDate = moment();

const diff = releaseDate.diff(currentDate);
const diffDuration = moment.duration(diff);

const handleMailTo = (x, e) => {
    const email = 'max.rose@audory.io';
    let subject = `Vorbestellung ${x}er Gutschein-Paket`;
    let body = `Liebes audory-Team,

hiermit möchte ich das "${x}er Gutschein-Paket" für ${e} € (inkl. MwSt.) vorbestellen.

Mir ist bewusst, dass ich das Gutschein-Paket erst bezahle und meine Gutscheine erhalte, sobald ihr gewerblich tätig seid (voraussichtlich am 10.12.2020).

Mit freundlichen Grüßen
VORNAME NACHNAME
`;
    subject = encodeURIComponent(subject);
    body = encodeURIComponent(body);
    window.location.href = `mailto:${email}?subject=${subject}&body=${body}`;
  }

const CoverImage = ({imageSrc, isPlaying, onClick}) => (
    <Grid.Column style={{position: 'relative', textAlign: 'center', cursor: 'pointer'}} onClick={() => onClick()}>
                                      
        <Image rounded src={imageSrc} />
        <Icon style={{position: 'absolute', color: 'white', top: '50%', left: '50%', transform: 'translate(-50%, -50%)'}} name={isPlaying ? 'pause circle' : 'video play'} size='huge' />
        
    </Grid.Column>
);

class GutscheinPage extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            audioSrc: null,
            audio: {},
            activePay: null,
        };
    }

    handleAudio(src){
        if(this.state.audioSrc === src){
            if(src in this.state.audio){
                this.state.audio[src].pause();
            }
            this.setState({audioSrc: null});
        } else {
            let audio = {...this.state.audio};
            if(this.state.audioSrc in this.state.audio){
                this.state.audio[this.state.audioSrc].pause();
            }
            if(!(src in this.state.audio)){
                audio = {...this.state.audio, [src]: new Audio(src)};
                audio[src].onended = () => {
                    this.setState({audioSrc: null});
                };
            }
            audio[src].play();
            this.setState({audio: audio, audioSrc: src});
        }
    }

    handlePaymentRequest(l){
        this.setState({activePay: null});
        window.open("https://pay.audory.io/pay/"+l,"_self");
    }

    render(){
        /*
<Header as='h3' style={{ fontSize: '2em', marginTop: '2em' }}>
                      <FormattedMessage id="audory.temp.4"/>
                    </Header>
        */
        return (
            <DivWrapper>
                <PageHeader />
              <Segment style={{ padding: '3em 0em', margin: 0 }}>
                  
                  <Container text>
          
                    
                    <p style={{ fontSize: '1.33em', textAlign: 'justify', marginBottom: '2em' }}>
                        <FormattedMessage id="audory.temp.5"/>{/*<FormattedMessage id="audory.temp.6"/> */}
                    </p>
          
                    <Grid centered style={{color: 'white'}}>
                        <Grid.Row style={{color: BACKGROUND_DARK2, fontSize: '1.6em'}}>
                            <FormattedMessage id="audory.temp.7"/>
                        </Grid.Row>
                        <Grid.Row only='computer' columns={3}>
                            <FirstOffer
                                handleSelect={() => this.setState({activePay: 0})}
                                isActivePay={this.state.activePay === 0}
                                handleBack={() => this.setState({activePay: null})}
                                handlePaymentRequest={(l) => this.handlePaymentRequest(l)}  />
                              
                            <SecondOffer
                                handleSelect={() => this.setState({activePay: 1})}
                                isActivePay={this.state.activePay === 1}
                                handleBack={() => this.setState({activePay: null})}
                                handlePaymentRequest={(l) => this.handlePaymentRequest(l)}  />
                            
                            <ThirdOffer
                                handleSelect={() => this.setState({activePay: 2})}
                                isActivePay={this.state.activePay === 2}
                                handleBack={() => this.setState({activePay: null})}
                                handlePaymentRequest={(l) => this.handlePaymentRequest(l)}  />

                        </Grid.Row>
                        <Grid.Row only='mobile tablet' columns={1}>
                            <FirstOffer
                                handleSelect={() => this.setState({activePay: 0})}
                                isActivePay={this.state.activePay === 0}
                                handleBack={() => this.setState({activePay: null})}
                                handlePaymentRequest={(l) => this.handlePaymentRequest(l)}  />
                        </Grid.Row>
                        <Grid.Row only='mobile tablet' columns={1}>
                            <SecondOffer
                                handleSelect={() => this.setState({activePay: 1})}
                                isActivePay={this.state.activePay === 1}
                                handleBack={() => this.setState({activePay: null})}
                                handlePaymentRequest={(l) => this.handlePaymentRequest(l)}  />
                        </Grid.Row>
                          
                        <Grid.Row only='mobile tablet' columns={1}>
                            <ThirdOffer
                                handleSelect={() => this.setState({activePay: 2})}
                                isActivePay={this.state.activePay === 2}
                                handleBack={() => this.setState({activePay: null})}
                                handlePaymentRequest={(l) => this.handlePaymentRequest(l)}  />
                        </Grid.Row>
                      </Grid>
          
                      <Header as='h3' style={{ fontSize: '2em', textAlign: 'justify', marginTop: '2em' }}>
                          <FormattedMessage id="audory.temp.1"/>
                      </Header>
                      <p style={{ fontSize: '1.33em', textAlign: 'justify', marginBottom: '3em' }}>
                      <FormattedMessage id="audory.temp.2"/><br/><br/>
                      <FormattedMessage id="audory.temp.3"/>
                      
                      </p>
          
                      <Grid centered>
                          <Grid.Row  only='computer' columns={3}>
                            <CoverImage imageSrc={stories[0][0]} isPlaying={this.state.audioSrc === stories[0][1]} onClick={() => this.handleAudio(stories[0][1])} />
                            <CoverImage imageSrc={stories[1][0]} isPlaying={this.state.audioSrc === stories[1][1]} onClick={() => this.handleAudio(stories[1][1])} />
                            <CoverImage imageSrc={stories[2][0]} isPlaying={this.state.audioSrc === stories[2][1]} onClick={() => this.handleAudio(stories[2][1])} />
                          </Grid.Row>
                          <Grid.Row only='computer' columns={3}>
                            <CoverImage imageSrc={stories[3][0]} isPlaying={this.state.audioSrc === stories[3][1]} onClick={() => this.handleAudio(stories[3][1])} />
                            <CoverImage imageSrc={stories[4][0]} isPlaying={this.state.audioSrc === stories[4][1]} onClick={() => this.handleAudio(stories[4][1])} />
                            <CoverImage imageSrc={stories[5][0]} isPlaying={this.state.audioSrc === stories[5][1]} onClick={() => this.handleAudio(stories[5][1])} />
                          </Grid.Row>
                          <Grid.Row only='computer' columns={3}>
                            <CoverImage imageSrc={stories[6][0]} isPlaying={this.state.audioSrc === stories[6][1]} onClick={() => this.handleAudio(stories[6][1])} />
                            <CoverImage imageSrc={stories[7][0]} isPlaying={this.state.audioSrc === stories[7][1]} onClick={() => this.handleAudio(stories[7][1])} />
                            <CoverImage imageSrc={stories[8][0]} isPlaying={this.state.audioSrc === stories[8][1]} onClick={() => this.handleAudio(stories[8][1])} />
                          </Grid.Row>
          
                          <Grid.Row  only='mobile tablet' columns={2}>
                            <CoverImage imageSrc={stories[0][0]} isPlaying={this.state.audioSrc === stories[0][1]} onClick={() => this.handleAudio(stories[0][1])} />
                            <CoverImage imageSrc={stories[1][0]} isPlaying={this.state.audioSrc === stories[1][1]} onClick={() => this.handleAudio(stories[1][1])} />
                          </Grid.Row>
                          <Grid.Row only='mobile tablet' columns={2}>
                            <CoverImage imageSrc={stories[2][0]} isPlaying={this.state.audioSrc === stories[2][1]} onClick={() => this.handleAudio(stories[2][1])} />
                            <CoverImage imageSrc={stories[3][0]} isPlaying={this.state.audioSrc === stories[3][1]} onClick={() => this.handleAudio(stories[3][1])} />
                          </Grid.Row>
                          <Grid.Row only='mobile tablet' columns={2}>
                            <CoverImage imageSrc={stories[4][0]} isPlaying={this.state.audioSrc === stories[4][1]} onClick={() => this.handleAudio(stories[4][1])} />
                            <CoverImage imageSrc={stories[5][0]} isPlaying={this.state.audioSrc === stories[5][1]} onClick={() => this.handleAudio(stories[5][1])} />
                          </Grid.Row>
                          <Grid.Row only='mobile tablet' columns={2}>
                            <CoverImage imageSrc={stories[6][0]} isPlaying={this.state.audioSrc === stories[6][1]} onClick={() => this.handleAudio(stories[6][1])} />
                            <CoverImage imageSrc={stories[7][0]} isPlaying={this.state.audioSrc === stories[7][1]} onClick={() => this.handleAudio(stories[7][1])} />
                          </Grid.Row>
                      </Grid>
          
                      
          
                      
          
                      
                      {
                          /*
          <p style={{ fontSize: '1.33em', textAlign: 'justify' }}>
                          <FormattedMessage id="audory.apppage.body.body2"/>
                      </p>
                          */
                      }
                      
          
                      
                      <Header as='h3' style={{ fontSize: '2em', marginTop: '2em' }}>
                      <FormattedMessage id="audory.temp.11"/>
                      </Header>
                      <p style={{ fontSize: '1.33em', textAlign: 'justify', marginBottom: '3em' }}>
                      <FormattedMessage id="audory.temp.12"/>
                      </p>
          
                      <Header as='h3' style={{ fontSize: '2em', textAlign: 'justify', marginTop: '2em' }}>
                          <center><Image src={appPreview} size='huge' /></center>
                          <Segment basic>
                          <Grid columns={2} centered>
                              <Grid.Column style={{textAlign: 'center'}}>
                                <Image as='a' href='https://apps.apple.com/app/id1538122365'  src={applePic} style={{width: '15em'}} />
                              </Grid.Column>
                              <Grid.Column style={{textAlign: 'center'}}>
                                <Image as='a' href='https://play.google.com/store/apps/details?id=com.audoryapp' src={googlePlayPic} style={{ width: '15em'}} />
                              </Grid.Column>
                            </Grid>
                          </Segment>
                      </Header>
          
          
                      
                      {
                          /*
                          <Header as='h3' style={{ fontSize: '2em', textAlign: 'justify', marginTop: '2em' }}>
                          <FormattedMessage id="audory.apppage.body.head3"/>
                      </Header>
                      <p style={{ fontSize: '1.33em', textAlign: 'justify', marginBottom: '2em' }}>
                          <FormattedMessage id="audory.apppage.body.body3"/>
                      </p>
          <center>
                          <Button
                              onClick={() => handleMailTo()}
                              color='green'
                              size='massive'
                              icon
                              labelPosition='left'
                              >
                              <Icon name='mail' />
                              <FormattedMessage id="audory.apppage.body.CTA"/>
                          </Button>
                      </center>
          
                          */
                      }
                      
                          
                  </Container>
              </Segment>
            </DivWrapper>
          );
    }
} 



const FirstOffer = ({handleSelect, isActivePay, handleBack, handlePaymentRequest}) => (
    <Grid.Column>
        {
            /*
<div style={{fontSize: '1.5em', textAlign: 'center', fontWeight: 'bold', color: BACKGROUND_DARK2}}>
            10er Paket
        </div>
            */
        }
        <Segment style={{backgroundColor: BACKGROUND_DARK2, borderRadius: 10}}>
            {
                /*
<Label as='a' color='grey' ribbon>
                Standard
            </Label>
                */
            }
            <center>
                <Grid centered>
                    <Grid.Row  only='computer' columns={1}>
                        <AudoryCoinIcon colors={{text: 'white', cardBackground: '#324b67', primary: '#72c9a5'}} width={'60%'}  />
                    </Grid.Row>
                    <Grid.Row  only='mobile tablet' columns={1}>
                        <AudoryCoinIcon colors={{text: 'white', cardBackground: '#324b67', primary: '#72c9a5'}} width={'50%'} />
                    </Grid.Row>
                </Grid>
            
                <div style={{fontSize: '1.3em', marginTop: '0.3em', fontWeight: 'bold'}}>
                    10 Hörtaler
                </div>
                <div style={{fontSize: '1em', marginTop: '0.6em'}}>
                    <s>9,99 €</s>
                </div>
                <div style={{fontSize: '3em', marginTop: '-0.2em'}}>
                    8,99 €
                </div>
                <div style={{ color: 'lightgrey', fontSize: '0.8em', marginTop: '0em'}}>
                    Du sparst 1,00 €
                </div>
            </center>
            <Table unstackable style={{backgroundColor: 'transparent', borderColor: 'transparent', color: 'white'}}>
                <Table.Body>
                    <Table.Row>
                        <Table.Cell collapsing>
                            <Icon name='check' color='green' />
                        </Table.Cell>
                        <Table.Cell textAlign='center'>
                        <FormattedMessage id="audory.temp.14"/>
                        </Table.Cell>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell collapsing>
                            <Icon name='check' color='green' />
                        </Table.Cell>
                        <Table.Cell textAlign='center'>
                            <FormattedMessage id="audory.temp.13"/> 10 %
                        </Table.Cell>
                    </Table.Row>
                </Table.Body>
            </Table>
            
            <div style={{ textAlign: 'center', marginBottom: '1em'}}>
                {
                    isActivePay ? (
                        <div>
                              <Button color='green' fluid icon labelPosition='right' onClick={() => handlePaymentRequest('ten')}>
                                Jetzt bestellen
                                <Icon name='paypal' />
                              </Button>
                              <div style={{color: 'white', marginTop: '1em', marginBottom: '1em', textAlign: 'justify'}}>
                                Mit Anklicken des Buttons „Jetzt bestellen“ erklärst du dich mit der Geltung und Einbeziehung unserer Verkaufsbedingungen einverstanden.
                              </div>
      
                              <Button as='a' fluid href='https://audory.io/cos' target="_blank" icon labelPosition='right'>
                                Verkaufsbedingungen
                                <Icon name='file text' />
                              </Button>
                              <Button style={{marginTop: '0.5em'}} onClick={() => handleBack()}>
                                Zurück
                              </Button>
                            </div>
                    ) : (
                        <div>
                            <Button color='green' fluid icon labelPosition='right' onClick={() => handleSelect()}>
                                Paket bestellen
                                <Icon name='paypal' />
                            </Button>
                        </div>
                    )
                }
            </div>
            
        </Segment>
    </Grid.Column>
);

const SecondOffer = ({handleSelect, isActivePay, handleBack, handlePaymentRequest}) => (
    <Grid.Column>
        {
            /*
<div style={{fontSize: '1.5em', textAlign: 'center', fontWeight: 'bold', color: BACKGROUND_DARK2}}>
            30er Paket
        </div>
            */
        }
        <Segment style={{backgroundColor: BACKGROUND_DARK2, borderRadius: 10}}>
            {
                /*
<Label as='a' color='green' ribbon>
            <FormattedMessage id="audory.temp.22"/>
            </Label>
                */
            }
            
            <center>
                <Grid centered>
                    <Grid.Row  only='computer' columns={1}>
                        <AudoryCoinIcon colors={{text: 'white', cardBackground: '#324b67', primary: '#72c9a5'}} width={'60%'}  />
                    </Grid.Row>
                    <Grid.Row  only='mobile tablet' columns={1}>
                        <AudoryCoinIcon colors={{text: 'white', cardBackground: '#324b67', primary: '#72c9a5'}} width={'50%'} />
                    </Grid.Row>
                </Grid>
                <div style={{fontSize: '1.3em', marginTop: '0.3em', fontWeight: 'bold'}}>
                    30 Hörtaler
                </div>
                <div style={{fontSize: '1em', marginTop: '0.6em'}}>
                    <s>29,97 €</s>
                </div>
                <div style={{fontSize: '3em', marginTop: '-0.2em'}}>
                    25,49 €
                </div>
                <div style={{ color: 'lightgrey', fontSize: '0.8em', marginTop: '0em'}}>
                    Du sparst 4,48 €
                </div>
            </center>
            <Table unstackable style={{backgroundColor: 'transparent', borderColor: 'transparent', color: 'white'}}>
                <Table.Body>
                    <Table.Row>
                        <Table.Cell collapsing>
                            <Icon name='check' color='green' />
                        </Table.Cell>
                        <Table.Cell textAlign='center'>
                            <FormattedMessage id="audory.temp.14"/>
                        </Table.Cell>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell collapsing>
                            <Icon name='check' color='green' />
                        </Table.Cell>
                        <Table.Cell textAlign='center'>
                        <FormattedMessage id="audory.temp.13"/> 15 %
                        </Table.Cell>
                    </Table.Row>
                </Table.Body>
            </Table>
            
            <div style={{ textAlign: 'center', marginBottom: '1em'}}>
                {
                    isActivePay ? (
                        <div>
                              <Button color='green' fluid icon labelPosition='right' onClick={() => handlePaymentRequest('thirty')}>
                                Jetzt bestellen
                                <Icon name='paypal' />
                              </Button>
                              <div style={{color: 'white', marginTop: '1em', marginBottom: '1em', textAlign: 'justify'}}>
                                Mit Anklicken des Buttons „Jetzt bestellen“ erklärst du dich mit der Geltung und Einbeziehung unserer Verkaufsbedingungen einverstanden.
                              </div>
      
                              <Button as='a' fluid href='https://audory.io/cos' target="_blank" icon labelPosition='right'>
                                Verkaufsbedingungen
                                <Icon name='file text' />
                              </Button>
                              <Button style={{marginTop: '0.5em'}} onClick={() => handleBack()}>
                                Zurück
                              </Button>
                            </div>
                    ) : (
                        <div>
                            <Button color='green' fluid icon labelPosition='right' onClick={() => handleSelect()}>
                                Paket bestellen
                                <Icon name='paypal' />
                            </Button>
                        </div>
                    )
                }
            </div>
            
        </Segment>
    </Grid.Column>
);

const ThirdOffer = ({handleSelect, isActivePay, handleBack, handlePaymentRequest}) => (
    <Grid.Column>
        {
            /*
<div style={{fontSize: '1.5em', textAlign: 'center', fontWeight: 'bold', color: BACKGROUND_DARK2}}>
            10er Paket
        </div>
            */
        }
        
        <Segment style={{backgroundColor: BACKGROUND_DARK2, borderRadius: 10}}>
            {
                /*
<Label as='a' color='green' ribbon>
            <FormattedMessage id="audory.temp.22"/>
            </Label>
                */
            }
            
            <center>
                <Grid centered>
                    <Grid.Row  only='computer' columns={1}>
                        <AudoryCoinIcon colors={{text: 'white', cardBackground: '#324b67', primary: '#72c9a5'}} width={'60%'}  />
                    </Grid.Row>
                    <Grid.Row  only='mobile tablet' columns={1}>
                        <AudoryCoinIcon colors={{text: 'white', cardBackground: '#324b67', primary: '#72c9a5'}} width={'50%'} />
                    </Grid.Row>
                </Grid>
                <div style={{fontSize: '1.3em', marginTop: '0.3em', fontWeight: 'bold'}}>
                    100 Hörtaler
                </div>
                <div style={{fontSize: '1em', marginTop: '0.6em'}}>
                    <s>99,90 €</s>
                </div>
                <div style={{fontSize: '3em', marginTop: '-0.2em'}}>
                    79,99 €
                </div>
                <div style={{ color: 'lightgrey', fontSize: '0.8em', marginTop: '0em'}}>
                    Du sparst 19,91 €
                </div>
            </center>
            <Table unstackable style={{backgroundColor: 'transparent', borderColor: 'transparent', color: 'white'}}>
                <Table.Body>
                    <Table.Row>
                        <Table.Cell collapsing>
                            <Icon name='check' color='green' />
                        </Table.Cell>
                        <Table.Cell textAlign='center'>
                        <FormattedMessage id="audory.temp.14"/>
                        </Table.Cell>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell collapsing>
                            <Icon name='check' color='green' />
                        </Table.Cell>
                        <Table.Cell textAlign='center'>
                        <FormattedMessage id="audory.temp.13"/> 20 %
                        </Table.Cell>
                    </Table.Row>
                </Table.Body>
            </Table>
            
            <div style={{ textAlign: 'center', marginBottom: '1em'}}>
                {
                    isActivePay ? (
                        <div>
                              <Button color='green' fluid icon labelPosition='right' onClick={() => handlePaymentRequest('hundred')}>
                                Jetzt bestellen
                                <Icon name='paypal' />
                              </Button>
                              <div style={{color: 'white', marginTop: '1em', marginBottom: '1em', textAlign: 'justify'}}>
                                Mit Anklicken des Buttons „Jetzt bestellen“ erklärst du dich mit der Geltung und Einbeziehung unserer Verkaufsbedingungen einverstanden.
                              </div>
      
                              <Button as='a' fluid href='https://audory.io/cos' target="_blank" icon labelPosition='right'>
                                Verkaufsbedingungen
                                <Icon name='file text' />
                              </Button>
                              <Button style={{marginTop: '0.5em'}} onClick={() => handleBack()}>
                                Zurück
                              </Button>
                            </div>
                    ) : (
                        <div>
                            <Button color='green' fluid icon labelPosition='right' onClick={() => handleSelect()}>
                                Paket bestellen
                                <Icon name='paypal' />
                            </Button>
                        </div>
                    )
                }
            </div>
            
        </Segment>
    </Grid.Column>
);

export default GutscheinPage;


// WEBPACK FOOTER //
// ./src/components/GutscheinPage.js